<template>
  <div>
    <section class="banner">
      <v-layout column align-center justify-center class="banner-bottom">
        <div class="familiacantu white--text text-xs-center">Família Cantu</div>
        <div class="brasil white--text text-xs-center">NO BRASIL</div>
        <img src="/static/img/Ativo 10@4x.png" alt="FAMILIA CANTU" width="400" height="25">
      </v-layout>
    </section>

    <section class="banner3">
      <v-layout
        column
        wrap
        class="mt-5 ml-5 mr-5"
        align-center
      >
        <v-flex xs12 sm4 class="mt-3 ml-3 mr-3">
          <v-layout column align-center justify-center>
            <div class="historia text-xs-center">GALERIA DE FOTOS</div>
            <hr class="historiahr">
            <v-layout wrap align-center>
              <v-flex xs12 sm8 offset-sm2>
                
                <v-layout wrap my-5 align-center  v-if="!dialogImage">
                  <v-flex xs12 sm4 class="my-1" v-for="(item, k) in galerias"
                      :key="k" >
                    
                    <img :src="item.images[0].image" alt="FAMILIA CANTU" height="200" width="250" @click.stop="openGallery(item)" class="cp">
                    <div class="text-imagem">{{item.dsGaleria}}</div>
                  </v-flex> 
                  <!-- <v-flex xs12 sm4 class="my-1" >
                    
                    <img src="/static/img/Ativo 14@4x.png" alt="FAMILIA CANTU" height="200" width="250">
                    <div class="text-imagem">Famílias</div>
                  </v-flex> 
                  <v-flex xs12 sm4 class="my-1">
                    
                    <img src="/static/img/Ativo 15@4x.png" alt="FAMILIA CANTU" height="200" width="250">
                    <div class="text-imagem">Registros</div>
                  </v-flex> 
                  <v-flex xs12 sm4 class="my-1" >
                    
                    <img src="/static/img/g_foto93404.jpg" alt="FAMILIA CANTU" height="200" width="250">
                    <div class="text-imagem">Família 1</div>
                  </v-flex> 
                  <v-flex xs12 sm4 class="my-1" >
                    
                    <img src="/static/img/Untithled-1.jpg" alt="FAMILIA CANTU" height="200" width="250">
                    <div class="text-imagem">Família 2</div>
                  </v-flex> 
                  <v-flex xs12 sm4 class="my-1" >
                    
                    <img src="/static/img/Untithled-1.jpg" alt="FAMILIA CANTU" height="200" width="250">
                    <div class="text-imagem">Família 3</div>
                  </v-flex>  -->
                </v-layout>
              </v-flex>
             
            </v-layout>
           
            
          </v-layout>
        </v-flex>
      </v-layout>
    </section>

    <v-dialog v-model="dialogImage2" max-width="70%">
      <v-card>
        <v-carousel v-model="carouselIndex">
          <v-carousel-item
            v-for="(item, x) in selected.images" :key="x" :src="item.image"
          ></v-carousel-item>
        </v-carousel>
      </v-card>    
    </v-dialog>

  <v-container v-if="dialogImage">
    <div class="box_gallery">
      <v-btn @click.stop="voltar()" class="vejamais">Voltar</v-btn>
    </div>
    
    <div class="gallery" @click.stop="openImage(i)">
      <div class="gallery-panel" v-for="(item, i) in selected.images" :key="i">
        <img :src="item.image" alt="FAMILIA CANTU" height="200" width="250" @click.stop="openImage(i)" />
      </div>
    </div>
  </v-container>



  </div>
</template>

<script>
import store from "../store";
import galeria from "@/services/galeria";

export default {
  name: 'Galeria',
  data () {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: {name: ""},
      galerias: [],
      message: "",
      selected: {
        images: []
      },
      dialogImage: false,
      dialogImage2: false,
      carouselIndex: 1,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
    }
  },
  async created () {
    this.galerias = await galeria.getGalerias();
  },
  methods: {
    openGallery(item) {
      if (item) {
        this.selected = item;
        this.dialogImage = true;
      }
    },
    openImage(img) {
      this.dialogImage2 = true;
      this.carouselIndex = img;
    },
    voltar() {
      this.selected = [];
      this.dialogImage = false;
      this.dialogImage2 = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner {
    background-image: url('/static/img/Ativo 14@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 850px;
    max-height: 100%;
    height: 260px;
    min-height: 260px;
    width: 100%;
    padding-top: 100px;
    position:relative; 
  }
  .brasil {
    font-size: 30px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historia {
    height: 20px + 2vw;
    font-size: 50px;
    color: #a56d30;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .text-imagem {
    font-size: 20px;
    color: #a56d30;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historiahr {
    width: 200px;
    border: 0; border-top: 1px solid #a56d30;
  }
  .familiacantu {
    height: 60px;
    widows: 220px;
    font-size: 60px;
    font-family: 'marguerite', sans-serif !important;
  }

  .box_gallery { max-width: 100rem; padding: 0 5rem; }
  .gallery img, .cp { cursor:pointer; }
  .gallery {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1rem;
    max-width: 100rem;
    margin: 5rem auto;
    padding: 0 5rem;
  }
  .gallery-panel img {
    width: 100%;
    height: 15vw;
    object-fit: cover;
    border-radius: 0.75rem;
  }
  
  .vejamais {
    background-color: #c99d66 !important;
    color: #333335;
    border-radius: 20%;
    text-transform: none;
    font-family: 'marguerite', sans-serif !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Galeria.vue